import { InventariosController } from "../../inventarios/InventariosController.js";
import { MuestreosController } from "../../muestreos/MuestreosController.js";

// Para agregar una nueva seccion:
// 1. Crear src/<seccion>/<Seccion>Controller.js con un metodo render()
// 2. Importarlo aqui
// 3. Agregar la ruta en el constructor

export class Router {
  constructor() {
    this.routes = {
      "":           (params) => InventariosController.render(params),
      inventarios:  (params) => InventariosController.render(params),
      muestreos:    (params) => MuestreosController.render(params),
    };
  }

  init() {
    window.addEventListener("hashchange", () => this.handleRoute());
    this.handleRoute();
  }

  handleRoute() {
    const hash = window.location.hash.slice(1) || "";
    const [path, queryString] = hash.split("?");
    const route = this.routes[path] || this.routes[""];
    const params = queryString ? new URLSearchParams(queryString) : new URLSearchParams();
    route(params);
  }

  navigate(path) {
    window.location.hash = path;
  }
}
